import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Image from "react-image";
import Pusher from "pusher-js";
import ReactPlayer from "react-player";
import CircularProgress from "@material-ui/core/CircularProgress";
import "bootstrap/dist/css/bootstrap.css";
import "./auto-play.css";
import "./restaurant-widget.css";
import ReactInterval from "react-interval";
import qrImg from "../asset/images/signStreamQR.png";
import WeatherComponent from "../WeatherComponent/WeatherComponent";
import signStram from "../asset/images/signstream-black.png";
import DOMPurify from "dompurify";
import RestaurantWidgetMenu from "./RestaurantWidgetMenu";
require("dotenv").config();

// const SS_API_ENDPOINT = "https://magic-slider-main-staging-4016704c2e32.herokuapp.com";
// const SS_API_ENDPOINT = "https://magic-slider-dev.herokuapp.com";
const SS_API_ENDPOINT =
  process.env.REACT_APP_BACKEND_URL || "https://app.signstream.net";

const useStyles = makeStyles((theme) => ({
  middle: {
    position: "absolute",
    top: "50%",
    left: "47%",
    transform: "translateY(-50%)",
  },
  progress: {
    margin: theme.spacing(0),
  },
}));

const CircularIndeterminate = () => {
  const classes = useStyles();

  return (
    <div className={classes.middle}>
      <CircularProgress className={classes.progress} color="secondary" />
    </div>
  );
};

class AutoPlayComponent extends React.Component {
  constructor(props) {
    super(props);
    this.popArtCache = {};
    this.healthEsignCache = {};
    this.state = {
      apiUrl: "https://stage.signstream.net/api/v1/channels/stage-86",
      isLoading: true,
      playBackData: [],
      currentDisplay: null,
      currentIndex: null,
      acceptedTypes: {
        image: "photo",
        video: "video",
        widget_youtube: "widget_youtube",
      },
      channelSetting: "",
      qrImgShow: false,
      currentMedia: -1,
      currentFlag: false,
      timeout: 3600000,
      enabled: true,
      qrCode: null,
      error: null,
    };
    this.videoPlayer = React.createRef();
    this.youtubePlayer = React.createRef();
  }

  componentWillMount() {
    const path = window.location.hostname.split("-")[0];
    if (path.toLowerCase().startsWith("stage")) {
      if (window.location.hostname.split(".")[1] === "signstream") {
        window.location.assign(
          "http://" +
            window.location.hostname.split(".")[0] +
            ".moiseszaragoza.com"
        );
      }
      this.setState(
        {
          apiUrl:
            `${SS_API_ENDPOINT}/api/v1/channels/` +
            window.location.hostname.split(".")[0],
        },
        function () {
          this.getData();
        }
      );
    } else {
      this.setState(
        {
          apiUrl:
            `${SS_API_ENDPOINT}/api/v1/channels/` +
            window.location.hostname.split(".")[0],
        },
        function () {
          let data = this.getData();
          return data;
        }
      );
    }
  }

  componentDidMount() {
    if (this.player) {
      this.player.getInternalPlayer().play();
    }

    // Check if QR should be shown and inject scripts accordingly
    // run on $10 channels or on demo channel with demo.signstream.net
    // const shouldShowQr = this.state.qrImgShow || (this.state.currentDisplay && this.state.currentDisplay.qrImgShow) || window.location.hostname.includes("demo.signstream.net");
    const shouldShowQr = window.location.hostname.includes(
      "fefa.signstream.net"
    );
    if (shouldShowQr) {
      this.injectGoogleAdScripts();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // const shouldShowQr = this.state.qrImgShow || (this.state.currentDisplay && this.state.currentDisplay.qrImgShow);
    // const prevShouldShowQr = prevState.qrImgShow || (prevState.currentDisplay && prevState.currentDisplay.qrImgShow);
    const shouldShowQr = window.location.hostname.includes(
      "fefa.signstream.net"
    );
    const prevShouldShowQr = window.location.hostname.includes(
      "fefa.signstream.net"
    );

    if (shouldShowQr && !prevShouldShowQr) {
      this.injectGoogleAdScripts();
    } else if (!shouldShowQr && prevShouldShowQr) {
      this.removeGoogleAdScripts();
    }
  }

  injectGoogleAdScripts = () => {
    // Remove existing scripts first to avoid duplicates
    this.removeGoogleAdScripts();

    // Add GPT script with crossorigin attribute for better compatibility
    const gptScript = document.createElement("script");
    gptScript.async = true;
    gptScript.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
    gptScript.crossOrigin = "anonymous";
    gptScript.id = "gpt-script";
    document.head.appendChild(gptScript);

    // Add GPT configuration script - using Premium Sticky Anchor (BOTTOM_ANCHOR)
    // This is the recommended format with better performance and +50% revenue uplift
    const configScript = document.createElement("script");
    configScript.id = "gpt-config-script";
    configScript.innerHTML = `
      window.googletag = window.googletag || { cmd: [] };
      var anchorSlot;
      googletag.cmd.push(function () {
        anchorSlot = googletag.defineOutOfPageSlot('/21849154601,23306131113/Ad.Plus-Anchor', googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR);
        if (anchorSlot) {
          anchorSlot.addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.enableServices();
          googletag.display(anchorSlot);
        }
      });
      setInterval(function(){
        if (anchorSlot) {
          googletag.pubads().refresh([anchorSlot]);
        }
      }, 30000);
    `;
    document.head.appendChild(configScript);

    // Remove Google Ad elements with data-vignette-loaded attribute
    setTimeout(() => {
      const vignetteAdElements = document.querySelectorAll(
        "ins[data-vignette-loaded]"
      );
      vignetteAdElements.forEach((element) => {
        element.remove();
      });
    }, 5000);
  };

  removeGoogleAdScripts = () => {
    const gptScript = document.getElementById("gpt-script");
    const configScript = document.getElementById("gpt-config-script");

    if (gptScript) {
      document.head.removeChild(gptScript);
    }
    if (configScript) {
      document.head.removeChild(configScript);
    }
  };

  changeDivContent = (currentDisplay, currentIndex, playBackData) => {
    const canPlay = this.checkScheduleStatus(currentDisplay);

    if (!canPlay) {
      if (
        playBackData &&
        playBackData.length === 2 &&
        playBackData[0].asset_id === playBackData[1].asset_id
      ) {
        //this is for edge case when we have only one asset in the schedule and it is not scheduled to play at this time.
        this.setState({
          isLoading: false,
          error:
            "No asset found to be scheduled to display at this time. Please check your schedule.",
        });
        return;
      } else if (playBackData && playBackData.length > 0) {
        // Check if all assets in playBackData are not scheduled to play at this time
        let allAssetsUnavailable = true;
        for (let i = 0; i < playBackData.length; i++) {
          if (this.checkScheduleStatus(playBackData[i])) {
            allAssetsUnavailable = false;
            break;
          }
        }

        // If all assets are unavailable, show error message
        if (allAssetsUnavailable) {
          this.setState({
            isLoading: false,
            error:
              "No asset found to be scheduled to display at this time. Please check your schedule.",
          });
          return;
        }
        let index =
          currentIndex === playBackData.length - 1 ? 0 : currentIndex + 1;
        this.changeDivContent(playBackData[index], index, playBackData);
      }
    }

    if (
      canPlay &&
      this.state.currentMedia === -1 &&
      this.state.currentFlag === false
    ) {
      this.setState(
        {
          currentDisplay,
          currentIndex,
          qrCode: currentDisplay.qrcode,
          isLoading: false,
        },
        () => {
          // State is now updated, proceed with the next slide
          this.reportAsset();

          setTimeout(() => {
            const { currentFlag } = this.state;
            // last video validation
            let index =
              currentIndex === playBackData.length - 1 ? 0 : currentIndex + 1;
            setTimeout(() => {
              const nextDisplay = playBackData[index];
              const canPlayNext = this.checkScheduleStatus(nextDisplay);

              if (!canPlayNext) {
                this.changeDivContent(nextDisplay, index, playBackData);
                return;
              }
              // Preload the next resource
              const nextResource = new Promise((resolve) => {
                const tag = document.createElement("div");
                tag.innerHTML = nextDisplay.content;
                resolve();
              });
              nextResource.then(() => {
                const nextDisplay = playBackData[index];
                switch (nextDisplay.asset_type) {
                  case "Image":
                    // Preload the image src
                    const img = document.createElement("img");
                    img.src = nextDisplay.file;
                    img.onload = () => {
                      setTimeout(
                        () => {
                          this.changeDivContent(
                            nextDisplay,
                            index,
                            playBackData
                          );
                        },
                        currentFlag ? 2000 : nextDisplay.duration * 1000 - 2000
                      );
                    };
                    break;
                  case "PopArt":
                    const popArtUrl =
                      nextDisplay.file +
                      "?orientation=" +
                      this.getPopArtOrientation(nextDisplay);
                    fetch(popArtUrl)
                      .then((response) => response.text())
                      .then((html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const imgTag = doc.querySelector("img");
                        const imageUrl = imgTag.getAttribute("src");
                        this.popArtCache[popArtUrl] = imageUrl;
                        const img = document.createElement("img");
                        img.src = imageUrl;
                        img.onload = () => {
                          // setTimeout(
                          //   () => {
                          this.changeDivContent(
                            nextDisplay,
                            index,
                            playBackData
                          );
                          // },
                          // currentFlag ? 2000 : nextDisplay.duration * 1000 - 2000
                          // );
                        };
                      });
                    break;
                  case "healthesign":
                    const healthEsignUrl = nextDisplay.file;
                    fetch(healthEsignUrl)
                      .then((response) => response.text())
                      .then((html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const imgTag = doc.querySelector("img");
                        const imageUrl = imgTag.getAttribute("src");
                        this.healthEsignCache[healthEsignUrl] = imageUrl;
                        const img = document.createElement("img");
                        img.src = imageUrl;
                        img.onload = () => {
                          // setTimeout(
                          //   () => {
                          this.changeDivContent(
                            nextDisplay,
                            index,
                            playBackData
                          );
                          // },
                          // currentFlag ? 2000 : nextDisplay.duration * 1000 - 2000
                          // );
                        };
                      });
                    break;
                  default:
                    this.changeDivContent(nextDisplay, index, playBackData);
                    break;
                }
              });
            }, 1000);
          }, currentDisplay.duration * 1000);
        }
      );
    }
  };

  ref = (player) => {
    this.player = player;
  };

  reportAsset = () => {
    fetch("https://api64.ipify.org?format=json")
      .then((res) => res.json())
      .then(
        (ipresponse) => {
          const { channelSetting, currentDisplay } = this.state;
          //var url = "https://magic-slider-reports-prod.herokuapp.com/";
          var url = `${SS_API_ENDPOINT}/api/v1/report_logs`;

          url = url + "?asset_id=" + currentDisplay.asset_id;
          url = url + "&account_id=" + channelSetting.account_id;
          url =
            url + "&is_touch=" + ("ontouchstart" in document.documentElement);
          url = url + "&channel_duration=" + channelSetting.channel_duration;
          url = url + "&channel_id=" + channelSetting.channel_id;
          url = url + "&url=" + window.location.href;
          url = url + "&duration=" + currentDisplay.duration;
          url = url + "&ip_address=" + ipresponse.ip;
          url = url + "&screen_height=" + window.innerWidth;
          url = url + "&screen_width=" + window.innerHeight;
          url = url + "&asset_owner=" + currentDisplay.asset_owner;
          url = url + "&subdomain=" + window.location.hostname.split(".")[0];
          url = url + "&is_public=" + currentDisplay.is_public;
          url =
            url +
            "&user_agent=" +
            window.navigator.userAgent.replace(/;/gi, "||");
          url =
            url + "&http_version=" + window.navigator.userAgent.split(" ")[0];
          url = url + "&language=" + window.navigator.language;
          fetch(url)
            .then(function (response) {
              return response;
            })
            .then(function (myJson) {});
        },
        (error) => {
          console.log(error.toString());
        }
      );
  };

  getData = () => {
    fetch(this.state.apiUrl)
      .then((res) => res.json())
      .then(
        (response) => {
          if (response && response.length > 0) {
            const channelSetting = response[0];
            this.setState({
              channelSetting,
            });
            const key = channelSetting.key;
            const pusher = new Pusher("89948d1d596d0c4b83f5", {
              cluster: "us2",
              encrypted: true,
            });
            var channel = pusher.subscribe(key.toString());
            channel.bind("my-event", function (data) {
              window.location.reload();
            });
            this.checkChannelContent(response);
          } else {
            this.setState({
              isLoading: false,
              error: "No AutoPlayBack data",
            });
          }
        },
        (error) => {
          this.setState({
            isLoading: false,
            error,
          });
        }
      );
  };

  checkScheduleStatus = (data) => {
    // If there's no schedule data, allow it to play
    if (!data || !data.channel_asset_schedule) return true;

    const now = new Date();
    const dayArray = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const dayNum = now.getDay();
    const dayString = dayArray[dayNum];

    const play = dayString.toLowerCase() + "_play";
    const start = dayString.toLowerCase() + "_start";
    const end = dayString.toLowerCase() + "_end";

    const playValue = data.channel_asset_schedule[play];
    const startValue = data.channel_asset_schedule[start];
    const endValue = data.channel_asset_schedule[end];

    // If play is set to false, don't play this asset today
    if (playValue === false) {
      return false;
    }

    // If play is true and no time restrictions (no start/end times), play it
    if (playValue === true && !startValue && !endValue) {
      return true;
    }

    // For time comparison, we only care about the time of day, not the actual date
    // Extract hours and minutes for current time
    const nowHours = now.getHours();
    const nowMinutes = now.getMinutes();

    // If there's a start time, check if current time is after start time
    if (startValue) {
      // Extract hours and minutes from start time
      const startDate = new Date(startValue);
      const startHours = startDate.getUTCHours();
      const startMinutes = startDate.getUTCMinutes();

      // Compare times (convert to minutes for easier comparison)
      const nowTotalMinutes = nowHours * 60 + nowMinutes;
      const startTotalMinutes = startHours * 60 + startMinutes;

      // If current time is before start time, don't play
      if (nowTotalMinutes < startTotalMinutes) {
        return false;
      }

      // If there's no end time but we're past start time, play it
      if (!endValue) {
        return true;
      }

      // If there's an end time, check if we're before the end time
      const endDate = new Date(endValue);
      const endHours = endDate.getUTCHours();
      const endMinutes = endDate.getUTCMinutes();

      const endTotalMinutes = endHours * 60 + endMinutes;
      const shouldPlay = nowTotalMinutes <= endTotalMinutes;
      return shouldPlay;
    }
    // If there's only an end time (no start time)
    else if (endValue) {
      const endDate = new Date(endValue);
      const endHours = endDate.getUTCHours();
      const endMinutes = endDate.getUTCMinutes();

      const nowTotalMinutes = nowHours * 60 + nowMinutes;
      const endTotalMinutes = endHours * 60 + endMinutes;

      const shouldPlay = nowTotalMinutes <= endTotalMinutes;
      return shouldPlay;
    }

    return true;
  };

  checkChannelContent = (resData) => {
    let playBackData = [];
    resData.forEach((data) => {
      if (data.show_logo) {
        this.setState({
          qrImgShow: true,
        });
      }
      if (data.asset_type) {
        playBackData.push(data);
      }
    });

    if (playBackData.length) {
      this.changeDivContent(playBackData[0], 0, playBackData);
    }
    // this.setState({
    //   isLoading: false,
    //   playBackData,
    // });
  };

  //To check if there are any items to be played currently.
  checkCurrentSchedule = () => {
    const { playBackData } = this.state;
    if (playBackData.length) {
      this.setState({ currentFlag: false });
      for (
        var playDataIndex = 0;
        playDataIndex < playBackData.length;
        playDataIndex++
      ) {
        const playData = playBackData[playDataIndex];
        if (playData.take_over_start_date) {
          const today = new Date();
          var isCurrent = true;
          const startDateString = playData.take_over_start_date;
          const startDateSplit = startDateString.split(".")[0];
          const startDate = new Date(startDateSplit);
          const deltaTime = today - startDate;

          //Start_date should be ealier than today
          if (deltaTime < 0) isCurrent = false;

          //To check if it is corresponded to take_over_repeat term
          if (playData.take_over_repeat.toLowerCase() === "weekly") {
            if (today.getDay() !== startDate.getDay()) isCurrent = false;
          }

          if (playData.take_over_repeat.toLowerCase() === "monthly") {
            if (today.getDate() !== startDate.getDate()) isCurrent = false;
          }

          if (
            playData.take_over_repeat.toLowerCase() === "daily" &&
            playData.take_over_start_time === null &&
            playData.take_over_end_time === null
          )
            isCurrent = false;

          //To check if current time is in the scope between take_over_start_time and take_over_end_time
          if (
            this.isOutPlayTime(
              playData.take_over_start_time,
              playData.take_over_end_time
            )
          )
            isCurrent = false;

          //If this is an item to be played now sets it as state.
          if (isCurrent === true) {
            this.setState({ currentFlag: true });
            if (this.state.currentIndex !== playDataIndex) {
              this.setState({
                currentDisplay: playData,
                currentIndex: playDataIndex,
                currentMedia: playDataIndex,
              });
            }
            break;
          }
        }
      }
      if (this.state.currentFlag === false) {
        this.setState({ currentMedia: -1 });
      }
    }
  };

  //To check if current time is in the scope between take_over_start_time and take_over_end_time
  isOutPlayTime = (overStartTime, overEndTime) => {
    if (overStartTime === null) overStartTime = "00:00";
    if (overEndTime === null) overEndTime = "23:59";

    //To convert all take_over times to minutes to make them easy to compare.
    var today = new Date();
    var todayTimeMin = today.getHours() * 60 + today.getMinutes();
    var overStartTimeMin =
      parseInt(overStartTime.substring(0, 2)) * 60 +
      parseInt(overStartTime.substring(3, 5));
    var overEndTimeMin =
      parseInt(overEndTime.substring(0, 2)) * 60 +
      parseInt(overEndTime.substring(3, 5));

    if (todayTimeMin < overStartTimeMin || todayTimeMin > overEndTimeMin)
      return true;

    return false;
  };

  getImageUrl(item) {
    if (window.innerWidth > window.innerHeight) {
      // Landscape
      return item.file;
    } else if (window.innerHeight > window.innerWidth && item.alternate_file) {
      // Portrait
      return item.alternate_file;
    } else {
      // Screen is portrait but alternate file is not present.
      return item.file;
    }
  }

  getPopArtOrientation(item) {
    if (item.orientation !== "dynamic") {
      return item.orientation;
    }
    if (window.innerWidth > window.innerHeight) {
      // Landscape
      return "landscape";
    } else {
      // Portrait
      return "portrait";
    }
  }

  renderItems(item, index) {
    const assets = item?.asset || [];

    // Retrieve the current index from localStorage
    let currentIndex = parseInt(localStorage?.getItem("currentIndex"), 10) || 0;

    // Function to handle switching to the next asset
    const handleNextAsset = () => {
      currentIndex = (currentIndex + 1) % assets.length;
      if (localStorage) {
        localStorage.setItem("currentIndex", currentIndex); // Store the new index in localStorage
        // set the link of the asset in the local storage from assets array
        localStorage.setItem("qrCodeLink", assets[currentIndex]?.link);
      }
    };

    if (item.asset_type === "RoughDraftWidget") {
      handleNextAsset();
    }

    const currentAsset = assets[currentIndex];
    const fadeOut = item.duration - 2;

    if (item) {
      let animationStyle = {};
      let fadeOutTransition = "";
      if (item.transitions === "fade-in") {
        animationStyle = { animation: item.transitions + " 4s" };
      } else {
        animationStyle = { animation: item.transitions + " 2s" };
        fadeOutTransition = "fade-out";
      }

      setTimeout(() => {
        if (fadeOutTransition === "fade-out") {
          animationStyle = { animation: fadeOutTransition + " 4s" };
        } else {
          animationStyle = { animation: fadeOutTransition + " 2s" };
        }
      }, (item.duration - fadeOut) * 1000);

      // if (fadeOutTransition === "fade-out") {
      //   animationStyle = { animation: fadeOutTransition + " 4s" };
      // } else {
      //   animationStyle = { animation: fadeOutTransition + " 2s" };
      // }

      switch (item.asset_type.toLowerCase()) {
        case "popart":
          const popArtUrl =
            item.file + "?orientation=" + this.getPopArtOrientation(item);
          const preloadedUrl = this.popArtCache[popArtUrl];
          if (preloadedUrl) {
            // If image URL preloaded, use it directly
            return (
              <div
                key={index}
                className={
                  "item " + (index === this.state.currentIndex ? "active" : "")
                }
                style={animationStyle}
              >
                <img
                  src={preloadedUrl}
                  className="popart-item"
                  alt={item.asset_type}
                />
              </div>
            );
          } else {
            // If image URL not preloaded, return iframe tag
            return (
              <div
                key={index}
                className={
                  "item " + (index === this.state.currentIndex ? "active" : "")
                }
                style={animationStyle}
              >
                <iframe
                  scrolling="no"
                  className="iframe-item"
                  allow="autoplay"
                  src={
                    item.file +
                    "?orientation=" +
                    this.getPopArtOrientation(item)
                  }
                  title={"website"}
                ></iframe>
              </div>
            );
          }
        case "widgetrestaurantmenu":
            return (
              <div
                key={index}
                className={
                  "item restaurant-widget-menu-item " +
                  (index === this.state.currentIndex ? "active" : "")
                }
                style={animationStyle}
              >
                <RestaurantWidgetMenu
                  html={item.html || ""}
                  active={index === this.state.currentIndex}
                />
              </div>
            );
        case "healthesign":
          const healthEsignUrl = item.file;
          const preloadedUrlhealthEsign = this.healthEsignCache[healthEsignUrl];
          if (preloadedUrlhealthEsign) {
            // If image URL preloaded, use it directly
            return (
              <div
                key={index}
                className={
                  "item " + (index === this.state.currentIndex ? "active" : "")
                }
                style={animationStyle}
              >
                <img
                  src={preloadedUrlhealthEsign}
                  className="popart-item"
                  alt={item.asset_type}
                />
              </div>
            );
          } else {
            // If image URL not preloaded, return iframe tag
            return (
              <div
                key={index}
                className={
                  "item " + (index === this.state.currentIndex ? "active" : "")
                }
                style={animationStyle}
              >
                <iframe
                  scrolling="no"
                  className="iframe-item"
                  allow="autoplay"
                  src={item.file}
                  title={"website"}
                ></iframe>
              </div>
            );
          }
        case "website":
          return (
            <div
              key={index}
              className={
                "item " + (index === this.state.currentIndex ? "active" : "")
              }
              style={animationStyle}
            >
              <iframe
                scrolling="no"
                className="iframe-item"
                allow="autoplay"
                src={item.file}
                title={"website"}
              ></iframe>
            </div>
          );
        case "weather":
          return (
            <div
              key={index}
              className={
                "item " + (index === this.state.currentIndex ? "active" : "")
              }
              style={animationStyle}
            >
              {
                <WeatherComponent
                  initialDay={item.weather_duration}
                  tempType={item.temp_unit ? item.temp_unit : "F"}
                  weatherCity={item.city}
                  weatherCountry={item.country}
                />
              }
            </div>
          );
        case "roughdraftwidget":
          return (
            <div
              key={index}
              className={
                "item " +
                (index === this.state.currentIndex ? "active" : "") +
                " bg-worldmap p-resposive-5"
              }
              style={animationStyle}
            >
              <div className="main-icon">
                <img
                  className="icon-image"
                  src={currentAsset.icon}
                  alt={currentAsset.asset_type}
                />
                <div className="byb">
                  <span className="byb-text">Brought to you by</span>
                  <img
                    className="signStram-image"
                    src={signStram}
                    alt="SignStream"
                  />
                </div>
              </div>

              <div className="main-text">
                <div className="heading-sec">
                  <h2 className="main-heading">{currentAsset.title}</h2>
                  <p
                    className="main-description"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(currentAsset.description),
                    }}
                  ></p>
                </div>
                <div className="main-image-sec">
                  <img
                    className="main-image"
                    src={currentAsset.image}
                    alt={currentAsset.asset_type}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          );
        case "image":
          const imageSrc = this.getImageUrl(item);
          return (
            <div
              key={index}
              className={
                "item " + (index === this.state.currentIndex ? "active" : "")
              }
              style={animationStyle}
            >
              {/* <img src={item.file} className="image-item" alt={item.asset_type} /> */}
              <Image
                className="image-item"
                src={imageSrc}
                // loader={/*any valid react element */}
              />
            </div>
          );
        case "widgetpexel":
          const pexelSrc = this.getImageUrl(item);
          return (
            <div
              key={index}
              className={
                "item " + (index === this.state.currentIndex ? "active" : "")
              }
              style={{
                animation: item.transitions ? item.transitions + " 2s" : "",
              }}
            >
              <Image src={pexelSrc} className="image-item" alt="WidgetPexel" />
            </div>
          );
        case "video":
          return (
            <div
              key={index}
              className={
                "item " + (index === this.state.currentIndex ? "active" : "")
              }
              style={animationStyle}
            >
              {index === this.state.currentIndex && (
                <ReactPlayer
                  ref={this.ref}
                  url={item.android_url}
                  className="react-player"
                  playing
                  controls
                  loop
                  volume={1}
                  muted={this.state.channelSetting.is_muted}
                  width={window.innerWidth}
                  height={window.innerHeight}
                />
              )}
            </div>
          );
        case "widget_youtube":
          return (
            <div
              key={index}
              className={
                "player-wrapper item " +
                (index === this.state.currentIndex ? "active" : "")
              }
              style={animationStyle}
            >
              {index === this.state.currentIndex && (
                <ReactPlayer
                  ref={this.ref}
                  url={
                    "https://www.youtube.com/watch?v=" +
                    item.embed_code +
                    "&autoplay=1"
                  }
                  className="react-player"
                  playing
                  controls
                  loop
                  volume={1}
                  muted={this.state.channelSetting.is_muted}
                  width={window.innerWidth}
                  height={window.innerHeight}
                />
              )}
            </div>
          );
        default:
          return null;
      }
    }
  }

  render() {
    const { isLoading, error, currentDisplay, currentIndex, enabled, timeout } =
      this.state;

    if (error) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            color: "white",
            textAlign: "center",
            padding: "20px",
            fontSize: "20px",
          }}
        >
          {error}
        </div>
      );
    } else if (isLoading) {
      return <CircularIndeterminate />;
    } else {
      return (
        <div className="content-wrapper">
          <ReactInterval
            {...{ timeout, enabled }}
            callback={() => this.checkCurrentSchedule()}
          />

          {
            // playBackData.map((item, index) => {
            //     return this.renderItems(item, index)
            // })

            this.renderItems(currentDisplay, currentIndex)
          }
          {((currentDisplay.asset_type === "RoughDraftWidget" &&
            this.state.qrCode === null) ||
            this.state.qrCode !== null) && (
            <div>
              <div className={`d-block d-sm-none`}>
                <div
                  className={`qrcode ${
                    currentDisplay?.asset_type === "RoughDraftWidget"
                      ? "qr-code-image"
                      : ""
                  }`}
                >
                  SCAN FOR INFO
                  <br />
                  <img
                    width={50}
                    src={
                      currentDisplay?.asset_type === "RoughDraftWidget"
                        ? localStorage?.getItem("qrCodeLink")
                        : this.state.qrCode
                    }
                    alt="SCAN FOR INFO"
                  />
                </div>
              </div>
              <div className="d-none d-sm-block d-md-none">
                <div
                  className={`qrcode ${
                    currentDisplay?.asset_type === "RoughDraftWidget"
                      ? "qr-code-image"
                      : ""
                  }`}
                >
                  SCAN FOR INFO
                  <br />
                  <img
                    width={75}
                    src={
                      currentDisplay?.asset_type === "RoughDraftWidget"
                        ? localStorage?.getItem("qrCodeLink")
                        : this.state.qrCode
                    }
                    alt="SCAN FOR INFO"
                  />
                </div>
              </div>
              <div className="d-none d-md-block d-lg-none">
                <div
                  className={`qrcode ${
                    currentDisplay?.asset_type === "RoughDraftWidget"
                      ? "qr-code-image"
                      : ""
                  }`}
                >
                  SCAN FOR INFO
                  <br />
                  <img
                    width={100}
                    src={
                      currentDisplay?.asset_type === "RoughDraftWidget"
                        ? localStorage?.getItem("qrCodeLink")
                        : this.state.qrCode
                    }
                    alt="SCAN FOR INFO"
                  />
                </div>
              </div>
              <div className="d-none d-lg-block">
                <div
                  className={`qrcode ${
                    currentDisplay?.asset_type === "RoughDraftWidget"
                      ? "qr-code-image"
                      : ""
                  }`}
                >
                  SCAN FOR INFO
                  <br />
                  <img
                    width={150}
                    src={
                      currentDisplay?.asset_type === "RoughDraftWidget"
                        ? localStorage?.getItem("qrCodeLink")
                        : this.state.qrCode
                    }
                    alt="SCAN FOR INFO"
                  />
                </div>
              </div>
            </div>
          )}
          {this.state.qrImgShow || currentDisplay.qrImgShow ? (
            <div>
              <div className="d-block d-sm-none">
                <div id="watermark">
                  <img width="50px" src={qrImg} alt={"watermark"} />
                </div>
              </div>
              <div className="d-none d-sm-block d-md-none">
                <div id="watermark">
                  <img width="75px" src={qrImg} alt={"watermark"} />
                </div>
              </div>
              <div className="d-none d-md-block d-lg-none">
                <div id="watermark">
                  <img width="100px" src={qrImg} alt={"watermark"} />
                </div>
              </div>
              <div className="d-none d-lg-block">
                <div id="watermark">
                  <img width="150px" src={qrImg} alt={"watermark"} />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      );
    }
  }
}

export default withRouter(AutoPlayComponent);
